import React from 'react';
import { styled } from 'styled-components';

type FlexProps = {
  children: React.ReactNode;
  gap?: string; // Accepts CSS gap values like '8px', '1rem', etc.
  direction?: 'row' | 'column';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  className?: string;
};

const FlexContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['gap', 'direction', 'alignItems', 'justify'].includes(prop),
})<FlexProps>`
  display: flex;
  gap: ${(props) => props.gap || '16px'};
  flex-direction: ${(props) => props.direction || 'row'};
  align-items: ${(props) => props.alignItems || 'stretch'};
  justify-content: ${(props) => props.justify || 'flex-start'};
`;

const Flex: React.FC<FlexProps> = ({
  children,
  gap = '16px',
  direction = 'row',
  alignItems = 'stretch',
  justify = 'flex-start',
  className = '',
}) => {
  return (
    <FlexContainer gap={gap} direction={direction} alignItems={alignItems} justify={justify} className={className}>
      {children}
    </FlexContainer>
  );
};

export default Flex;
